export default __webpack_public_path__ + "static/media/toggle-bg.3c3dc4a0.png";